import Home from "./views/home"
import Dashboard from "./views/dashboard"
import NotAuthorized from "./components/not-authorized"
import PageNotFound from "./components/page-not-found"
import WorkloadsIndex from "./views/workloads/approved-workloads"
import WorkloadsDenied from "./views/workloads/denied-workloads"
import WorkloadsPending from "./views/workloads/pending-workloads"
import WorkloadsAdd from "./views/workloads/workload-add"
import WorkloadsEdit from "./views/workloads/workload-edit"
import WorkloadsDetails from "./views/workloads/workload-details"
import MyWorkloads from "./views/workloads/workload-dashboard"
import FacultyUnsubmitted from "./views/employees/unsubmitted-faculty"
import FacultyWorkloads from "./views/employees/all-faculty-workloads"
import FacultyCoursePlan from "./views/employees/course-plan"
import FacultyDetails from "./views/employees/faculty-details"

import About from "./views/about"
import Reports from "./views/reports"
import BuyoutRequests from "./views/buyout-requests/buyout-requests"
import BuyoutRequestDetails from "./views/buyout-requests/details"

import AdminRequests from "./views/admin-requests/admin-requests"
import AdminRequestDetails from "./views/admin-requests/details"

import AffiliateRequests from "./views/affiliate-work/affiliate-work-requests"
import AffiliateRequestDetails from "./views/affiliate-work/details.vue"

import CourseEquivalents from "./views/course-equivalents/course-equivalents"
import CourseEquivalentDetails from "./views/course-equivalents/details.vue"

import OverageRequests from "./views/overage-requests/overage-requests"

import SummerPayRequests from "./views/summer-pay/summer-pay-requests"
import PayRequestDetails from "./views/summer-pay/details"
import summerPayAdd from "./views/summer-pay/add-summer-pay"

import Roles from "./misc/roles"

const USER_ROLES = Roles

export const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    display: "Home",
    meta: {
      roles: [USER_ROLES.all],
    },
  },
  {
    path: "/summer-pay/add",
    name: "summerPayAdd",
    component: summerPayAdd,
    display: "Add Request",
    props: true,
    meta: {
      roles: [USER_ROLES.spManager, USER_ROLES.spSubmitter],
    },
  },
  {
    path: "/summer-pay",
    name: "SummerPayRequests",
    display: "Summer Pay List",
    component: SummerPayRequests,
    props: true,
    meta: {
      roles: [
        USER_ROLES.spManager,
        USER_ROLES.spViewer,
        USER_ROLES.spSubmitter,
      ],
    },
  },
  {
    path: "/summer-pay/:id",
    name: "PayRequestDetails",
    display: "Item ID",
    component: PayRequestDetails,
    props: true,
    meta: {
      roles: [
        USER_ROLES.spManager,
        USER_ROLES.spViewer,
        USER_ROLES.spSubmitter,
      ],
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    display: "My Dashboard",
    meta: {
      roles: [USER_ROLES.all],
    },
  },
  {
    path: "/about",
    name: "about",
    component: About,
    display: "About",
  },
  {
    path: "/reports",
    name: "reports",
    component: Reports,
    display: "Reports",
    meta: {
      roles: [USER_ROLES.workloadsManager, USER_ROLES.workloadsViewer],
    },
  },
  {
    path: "/impersonation/:asuriteId",
    name: "impersonation",
    component: Home,
    props: true,
    display: "Impersonation",
    meta: {
      roles: [USER_ROLES.impersonation],
    },
  },
  {
    path: "/stopimpersonation",
    name: "stopimpersonation",
    component: Home,
    props: true,
    display: "StopImpersonation",
  },
  {
    path: "/not-authorized",
    name: "notAuthorized",
    component: NotAuthorized,
    display: "Not Authorized",
  },
  {
    path: "/workloads",
    name: "myWorkloads",
    component: MyWorkloads,
    dispaly: "Add Workload",
    meta: {
      //      roles: [USER_ROLES.employee]
      roles: [USER_ROLES.workloadsSubmitter],
    },
  },
  {
    path: "/workloads/approved",
    name: "workloads",
    component: WorkloadsIndex,
    display: "Approved Workloads",
    meta: {
      roles: [USER_ROLES.workloadsManager, USER_ROLES.workloadsViewer],
    },
  },
  {
    path: "/workloads/denied",
    name: "deniedWorkloads",
    component: WorkloadsDenied,
    display: "Denied Workloads",
    meta: {
      roles: [USER_ROLES.workloadsManager, USER_ROLES.workloadsViewer],
    },
  },
  {
    path: "/workloads/pending",
    name: "pendingWorkloads",
    component: WorkloadsPending,
    display: "Pending Workloads",
    meta: {
      roles: [USER_ROLES.workloadsManager, USER_ROLES.workloadsViewer],
    },
  },
  {
    path: "/workloads/add",
    name: "workloadAdd",
    component: WorkloadsAdd,
    display: "Add Workload",
    props: true,
    meta: {
      roles: [USER_ROLES.workloadsSubmitter],
    },
  },
  {
    path: "/workloads/add/:asurite",
    name: "workloadAddBehalf",
    component: WorkloadsAdd,
    display: "Add Workload",
    props: true,
    meta: {
      roles: [USER_ROLES.workloadsManager],
    },
  },
  {
    path: "/workloads/edit/:workloadId",
    name: "workloadEdit",
    component: WorkloadsEdit,
    display: "Edit Workload",
    props: true,
    meta: {
      roles: [USER_ROLES.workloadsSubmitter],
    },
  },
  {
    path: "/workloads/:workloadId",
    name: "workload",
    component: WorkloadsDetails,
    display: "Workload Details",
    props: true,
    meta: {
      roles: [
        USER_ROLES.workloadsViewer,
        USER_ROLES.workloadsManager,
        USER_ROLES.workloadsSubmitter,
      ],
    },
  },
  {
    path: "/employees/faculty/:asuriteId",
    name: "facultyDetails",
    component: FacultyDetails,
    display: "Faculty",
    props: true,
    meta: {
      roles: [
        USER_ROLES.employeesViewer,
        // USER_ROLES.facultyHead,
        // USER_ROLES.viewOnly,
        // USER_ROLES.degreeCoordinator,
        // USER_ROLES.expertsViewer,
        // USER_ROLES.expertsAdmin,
        // USER_ROLES.expertsEditor,
        // USER_ROLES.buyoutManager
      ],
    },
  },
  {
    path: "/employees/workloads",
    name: "facultyWorkloads",
    component: FacultyWorkloads,
    display: "All Faculty",
    meta: {
      roles: [
        USER_ROLES.workloadsViewer,
        USER_ROLES.workloadsManager,
        USER_ROLES.workloadsSubmitter,
        // USER_ROLES.facultyHead,
        // USER_ROLES.viewOnly,
        // USER_ROLES.degreeCoordinator
      ],
    },
  },
  {
    path: "/employees/course-plan",
    name: "facultyCoursePlan",
    component: FacultyCoursePlan,
    display: "Course Plan",
    meta: {
      roles: [
        //   USER_ROLES.facultyHead,
        //   USER_ROLES.viewOnly,
        //   USER_ROLES.degreeCoordinator
        USER_ROLES.workloadsViewer,
        USER_ROLES.workloadsManager,
        USER_ROLES.workloadsSubmitter,
      ],
    },
  },
  {
    path: "/employees/unsubmitted",
    name: "facultyUnsubmitted",
    component: FacultyUnsubmitted,
    display: "Unsubmitted Employees",
    meta: {
      roles: [
        USER_ROLES.workloadsViewer,
        USER_ROLES.workloadsManager,
        USER_ROLES.workloadsSubmitter,
      ],
    },
  },
  {
    path: "/overage-requests",
    name: "overloadRequests",
    component: OverageRequests,
    display: "Overload Requests",
    meta: {
      //     roles: [USER_ROLES.degreeCoordinator, USER_ROLES.facultyHead
      roles: [USER_ROLES.overloadsManager],
    },
  },
  {
    path: "/buyout-requests",
    name: "buyoutRequests",
    component: BuyoutRequests,
    display: "Buyout Requests",
    meta: {
      roles: [USER_ROLES.buyoutManager, USER_ROLES.buyoutViewer],
    },
  },
  {
    path: "/buyout-requests/:id",
    name: "buyoutRequestDetails",
    props: true,
    component: BuyoutRequestDetails,
    display: "Buyout Request Details",
    meta: {
      roles: [
        USER_ROLES.buyoutManager,
        USER_ROLES.buyoutViewer,
        USER_ROLES.workloadsSubmitter,
      ],
    },
  },
  {
    path: "/administrative-requests",
    name: "adminRequests",
    component: AdminRequests,
    display: "Administrative Requests",
    meta: {
      roles: [USER_ROLES.adminSupervisor, USER_ROLES.adminViewer],
    },
  },
  {
    path: "/administrative-requests/:id",
    name: "adminRequestDetails",
    props: true,
    component: AdminRequestDetails,
    display: "Administrative Request Details",
    meta: {
      roles: [USER_ROLES.adminSupervisor, USER_ROLES.adminViewer],
    },
  },
  {
    path: "/affiliate-requests",
    name: "affiliateRequests",
    component: AffiliateRequests,
    display: "Affiliate Requests",
    meta: {
      roles: [USER_ROLES.affiliateRequestsViewer],
    },
  },
  {
    path: "/affiliate-requests/:id",
    name: "affiliateRequestDetails",
    props: true,
    component: AffiliateRequestDetails,
    display: "Affiliate Request Details",
    meta: {
      roles: [USER_ROLES.affiliateRequestsViewer],
    },
  },
  {
    path: "/course-equivalents",
    name: "courseEquivalents",
    component: CourseEquivalents,
    display: "Course Equivalents",
    meta: {
      roles: [
        USER_ROLES.courseEquivalentsManager,
        USER_ROLES.courseEquivalentsViewer,
      ],
    },
  },
  {
    path: "/course-equivalents/:id",
    name: "courseEquivalentDetails",
    props: true,
    component: CourseEquivalentDetails,
    display: "Course Equivalent",
    meta: {
      roles: [
        USER_ROLES.courseEquivalentsManager,
        USER_ROLES.courseEquivalentsViewer,
      ],
    },
  },
  {
    path: "/summer-pay-requests/:id",
    name: "payRequestDetails",
    props: true,
    component: PayRequestDetails,
    display: "Summer Pay Request Details",
    meta: {
      roles: [
        USER_ROLES.spManager,
        USER_ROLES.spSubmitter,
        USER_ROLES.spViewer,
      ],
    },
  },
  {
    path: "*",
    component: PageNotFound,
  },
]
